import React from 'react';
import { Modal } from 'antd';
import ThemeDrawer from '@base/lib/ThemeDrawer';
import type { IPopupsCode } from 'mod/feature/interface';
import { IPopupModalCode, IPopupShowType } from 'mod/feature/interface';
import BlackFridayCheckIn, { popupProps as BlackFridayCheckInProps } from '@app/activity/BlackFridayCheckIn';
import Iconfont from '@base/lib/Iconfont';

type IProps = {
    visible: boolean;
    popUpsCode?: IPopupsCode;
    setVisible: any;
}

type IChildComponent = {
    code: IPopupModalCode
}

// IPopupModalCode 对应内容的 Modal 弹窗配置
const modalPropsMap = {
    'blackFridaySignIn': BlackFridayCheckInProps
}

// 内容
const ChildComponent: React.FC<IChildComponent> = (props) => {
    const { code } = props

    switch (code) {
        case 'blackFridaySignIn':
            return <BlackFridayCheckIn/>
        default:
            return <></>
    }
}

const PopupDrawerModal: React.FC<IProps> = (props) => {

    const { popUpsCode, setVisible, visible } = props

    if (!popUpsCode) {
        return null
    }

    const popupParams = popUpsCode.trim()?.split(':')
    const showType = popupParams[0] || 'popup' as IPopupShowType
    const contentCode = popupParams[1] as IPopupModalCode

    const ModalCom = showType == 'popup' ? Modal : ThemeDrawer

    const modalCloseProps = showType == 'popup' ? {
        onCancel: () => setVisible(false)
    } : {
        onClose: () => setVisible(false)
    }

    // 每个活动的配置
    const modalConfigProps = modalPropsMap[contentCode]

    return (
        <div>
            <ModalCom
                closeIcon={<Iconfont className={'icon-x'}/>}
                onCancel={() => setVisible(false)}
                onClose={() => setVisible(false)}
                onOk={() => setVisible(false)}
                open={visible}
                destroyOnClose
                {...modalConfigProps}
                {...modalCloseProps}
            >

                <ChildComponent code={contentCode}/>

            </ModalCom>
        </div>
    );
};

export default PopupDrawerModal